import { createContext, useContext } from "react";
import type { DaContextStates } from "./types";

export const daContextInitialState: DaContextStates = {
  filters: { selectedAnswerStatus: "all", selectedModuleGroup: undefined },
  setFilters: () => {},
  page: 1,
  pageSize: 5,
  setPage: () => {},
  total: 0,
  setTotal: () => {},
};

const context = createContext<DaContextStates>(daContextInitialState);
export const useDaContext = () => useContext(context);
export const DaContextProvider = context.Provider;
